import React from 'react'

const Attention = () => {
  return (
    <div id="attention" className='absolute bottom-3'>
      本アプリはβ版であり、データの間違いが存在する可能性があります。重要な意思決定の際には元データをご確認ください。
    </div>
  )
}

export default Attention